import { Phone, CalendarSync, MessageCircle } from "lucide-react";

/** Tap-to-call + WhatsApp chips for a task linked to a lead. */
export function ClientPhone({ task, className = "" }) {
  if (!task.lead_phone) return null;
  const digits = String(task.lead_phone).replace(/[^0-9]/g, "");
  const wa = `https://wa.me/${digits.length === 10 ? "91" + digits : digits}`;
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5">
      <a
        href={`tel:${String(task.lead_phone).replace(/[^0-9+]/g, "")}`}
        onClick={(e) => e.stopPropagation()}
        data-testid={`task-phone-${task.id}`}
        className={`inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold tabular-nums text-emerald-700 ring-1 ring-emerald-200 transition-colors hover:bg-emerald-100 ${className}`}
      >
        <Phone className="h-3 w-3" /> {task.lead_name ? `${task.lead_name.trim()} · ` : ""}{task.lead_phone}
      </a>
      <a
        href={wa}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        data-testid={`task-whatsapp-${task.id}`}
        aria-label={`WhatsApp ${task.lead_name || task.lead_phone}`}
        className="inline-flex items-center gap-1 rounded-full bg-[#25D366] px-2 py-0.5 text-[11px] font-semibold text-white transition-[filter] hover:brightness-110"
      >
        <MessageCircle className="h-3 w-3" /> WhatsApp
      </a>
    </span>
  );
}

export function RescheduleTaskButton({ task, onClick, testid }) {
  if (task.done) return null;
  return (
    <button
      onClick={(e) => { e.stopPropagation(); onClick(task); }}
      data-testid={testid || `task-reschedule-${task.id}`}
      className="inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-[11px] font-semibold text-amber-800 transition-colors hover:bg-amber-100"
    >
      <CalendarSync className="h-3 w-3" /> Reschedule
    </button>
  );
}
